import React from 'react';
import { formatPriceDisplay } from '../../utils/wineDataUtils';

const WineCard = ({ 
  wine, 
  onTellMeMore, 
  isLoading = false,
  className = ''
}) => {
  return (
    <div className={`wine-style-card carousel-card ${className}`}>
      <div className="wine-style-header">
        <div className="wine-style-rank">#{wine.rank}</div>
        <div className="wine-style-name">{wine.title}</div>
        
        {/* Show wine type badge for eating in flow */}
        {wine.subtitle && (
          <div className="wine-type-badge">{wine.subtitle}</div>
        )}
        
        {/* Show price badge for eating out flow */}
        {wine.price && (
          <div className="wine-price-badge">
            {formatPriceDisplay(wine.price)}
          </div>
        )}
      </div>
      
      <div className="wine-style-details">
        <div className="wine-detail-row">
          <span className="detail-label">Grapes:</span>
          <span className="detail-value">{wine.details.grapes || 'N/A'}</span>
        </div>
        <div className="wine-detail-row">
          <span className="detail-label">Region:</span>
          <span className="detail-value">{wine.details.region || 'N/A'}</span>
        </div>
        <div className="wine-detail-row">
          <span className="detail-label">Character:</span>
          <span className="detail-value">{wine.details.characteristics || 'N/A'}</span>
        </div>
      </div>
      
      <div className="wine-pairing-reason">
        <h4>{wine.price ? 'Why this works well:' : 'Why this pairs well:'}</h4>
        <p>{wine.reason}</p>
      </div>
      
      {/* Price guidance for eating in flow */}
      {!wine.price && wine.originalData?.price_guidance && (
        <div className="wine-price-guidance">
          <span className="price-label">💰 Budget tip:</span>
          <span className="price-value">{wine.originalData.price_guidance}</span>
        </div>
      )}
      
      <div className="wine-card-actions">
        <button 
          className="tell-me-more-btn" 
          onClick={onTellMeMore}
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Tell me more'}
        </button>
      </div>
    </div>
  );
};

export default WineCard;
